<template>
<div class="container">
    <div id="jobApplication" class="mt-lg-6 mt-2">
        <FormKit
            type="form"
            :form-class="submitted ? 'hide' : 'show'"
            :submit-label="translationStrings.applicationSubmit"
            @submit="submitApplication"
        >
            <div v-if="formheadline || formdesc" class="form__header mb-4">
                <h3 v-if="formheadline">{{formheadline}}</h3>
                <div
                    v-if="formdesc"
                    v-html="formdesc"
                    class="formDesc">
                </div>
            </div>
            <div class="form__row">
                <FormKit
                    id="first_name"
                    type="text"
                    :placeholder="translationStrings.applicationName"
                    name="first_name"
                    :label="translationStrings.applicationNameLabel"
                    validation="required"
                />
                <FormKit
                    id="last_name"
                    type="text"
                    :placeholder="translationStrings.applicationLastName"
                    name="last_name"
                    :label="translationStrings.applicationLastNameLabel"
                    validation="required"
                />
            </div>
            <FormKit
                id="mail"
                type="email"
                :placeholder="translationStrings.applicationLastEmail"
                name="mail"
                :label="translationStrings.applicationLastEmail"
                validation="required"
            />
            <FormKit
                id="phone"
                type="tel"
                name="phone"
                :label="translationStrings.applicationLastPhoneLabel"
                :placeholder="translationStrings.applicationLastPhone"
                validation="required"
            />
            <div class="form__row">
                <FormKit
                    id="available_from"
                    type="date"
                    name="available_from"
                    :value="today"
                    :label="translationStrings.applicationLastAvailableLabel"
                    validation-visibility="live"
                />

                <FormKit
                    id="salary_expectations"
                    type="number"
                    :label="translationStrings.applicationLastSalaryLabel"
                    :placeholder="translationStrings.applicationLastSalary"
                    name="salary_expectations"
                    step="1"
                />
            </div>

            <div v-if="formdocsheadline || formdocsdesc" class="form__header mb-lg-4 mb-3 mt-lg-5 mt-4">
                <h4 v-if="formdocsheadline">{{formdocsheadline}}</h4>
                <div
                    v-if="formdocsdesc"
                    v-html="formdocsdesc"
                    class="formDocsDesc">
                </div>
            </div>

            <div
                class="dropArea__container my-3"
                :class="[{'hasFiles' : uploadedFiles.length}]"
            >
                <label for="uploadInput">{{translationStrings.uploadInputLabel}}</label>
                <div class="dropArea" @drop.prevent="personioDocumentUpload" @dragover.prevent>
                    <button @click.prevent="browseForFiles">
                        <i class="icon-UploadSimple"></i>
                        <span v-html="translationStrings.uploadInputPlace"></span>
                        <span v-html="translationStrings.uploadInputLimit"></span>
                    </button>
                    <input
                        type="file"
                        ref="uploadInput"
                        name="uploadInput"
                        @change.prevent="personioDocumentUpload"
                        multiple
                        hidden
                    />
                </div>
                <div v-if="uploadedFiles" class="dropArea__uploads">
                    <div
                        v-for="file in uploadedFiles"
                        :key="file.uuid"
                        class="dropArea__uploads__file"
                        @click="removeFile(file.uuid)"
                    >
                        <strong>
                            {{file.original_filename}}
                        </strong> <span>{{translationStrings.uploadInputDelete}}</span> <i class="icon-TrashSimple"></i>
                    </div>

                </div>
            </div>

            <div class="form__dsgvo mb-4">
                <FormKit
                    type="checkbox"
                    :name="translationStrings.applicationLastDsgvoLabel"
                    id="dsgvo"
                    validation="accepted"
                    validation-visibility="dirty"
                />
                <label for="dsgvo" v-html="formdsgvotext"></label>
            </div>

            <div
                v-if="errors"
                class="jobApplication__errors mb-4"
            >
                <p>
                    {{translationStrings.applicationLastErrorLabel}} <br/>
                    <span
                        v-for="error in errors.errors"
                        :key="error.field"
                        style="color:red; font-weight: bold;"
                    >
                        {{error.field}}:
                        <span
                            v-for="reason in error.errors"
                            :key="reason.reason"
                            style="color:red; font-weight: bold;"
                        >
                            {{reason.reason}}
                        </span> <br/>

                    </span>
                </p>
            </div>
        </FormKit>

        <div
            v-if="submitted"
            class="jobApplication__submitted"
            v-html="formsubmitted"
        ></div>
    </div>
</div>
</template>

<script>
import {
// computed,
    ref,
} from 'vue/dist/vue.esm-bundler';
import { useStore } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import '@formkit/themes/genesis';

export default {
    name: 'JobApplication',
    props: {
        personioid: {
            type: String,
            default: ''
        },
        formheadline: {
            type: String,
            default: ''
        },
        formdesc: {
            type: String,
            default: ''
        },
        formdocsheadline: {
            type: String,
            default: ''
        },
        formdocsdesc: {
            type: String,
            default: ''
        },
        formdsgvotext: {
            type: String,
            default: ''
        },
        formsubmitted: {
            type: String,
            default: ''
        },
    },
    setup(props) {
        const store = useStore();
        const uploadInput = ref(null);
        const uploadedFiles = ref([]);
        const submitted = ref(false);
        const { translationStrings } = wpUrls;
        const errors = ref('');

        let today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();

        today = `${yyyy}-${mm}-${dd}`;

        const browseForFiles = () => {
            uploadInput.value.click();
        };

        const personioDocumentUpload = async(e) => {
            let droppedFiles;

            if (e.dataTransfer) {
                droppedFiles = e.dataTransfer.files;
            } else if (e.target.files) {
                droppedFiles = e.target.files;
            }

            console.log(droppedFiles);

            if (!droppedFiles) return;
            const formData = new FormData();
            ([...droppedFiles]).forEach((f, x) => {
                formData.append(`file_${x + 1}`, f);
            });

            console.log(formData);

            const response = await store.state.api.post('/jobs/v1/documentupload', formData);

            response.data.forEach((file) => {
                uploadedFiles.value.push(JSON.parse(file));
            });

            // uploadedFiles.value.push(response.data.map((e) => JSON.parse(e)));
        };

        const submitApplication = async(submitData) => {
            const applicationData = {
                job_position_id: props.personioid,
                first_name: submitData.first_name,
                last_name: submitData.last_name,
                email: submitData.mail,
                application_date: today,
                files: [],
                attributes: [
                    {
                        id: 'phone',
                        value: submitData.phone
                    }
                ]
            };

            if (submitData.available_from) {
                applicationData.attributes.push(
                    {
                        id: 'available_from',
                        value: submitData.available_from
                    }
                );
            }

            if (submitData.salary_expectations) {
                applicationData.attributes.push(
                    {
                        id: 'salary_expectations',
                        value: submitData.salary_expectations
                    }
                );
            }

            uploadedFiles.value.forEach((file) => {
                const fileData = {
                    uuid: file.uuid,
                    original_filename: file.original_filename,
                    category: 'other'
                };

                applicationData.files.push(fileData);
            });

            const response = await store.state.api.post('/jobs/v1/submitapplication', applicationData);
            if (response.data !== '') {
                // eslint-disable-next-line no-console
                console.log(JSON.parse(response.data));
                errors.value = JSON.parse(response.data);
            } else {
                submitted.value = true;
            }
        };

        const removeFile = (fileId) => {
            const fileIndex = uploadedFiles.value.findIndex((e) => e.uuid === fileId);

            uploadedFiles.value.splice(fileIndex, 1);
        };

        return {
            uploadInput,
            browseForFiles,
            personioDocumentUpload,
            uploadedFiles,
            removeFile,
            submitApplication,
            today,
            submitted,
            translationStrings,
            errors,
        };
    }
};
</script>

<style lang="scss">
@import '../../../scss/hm/hmVars';

.formkit-wrapper, .formkit-fieldset {
    max-width: 100%;
}

.form__row {
    @media (min-width: 992px) {
        display: flex;
        gap: 32px;

        & > div {
            flex: 1 1 auto;
        }
    }
}

.dropArea {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $white;
    // eslint-disable-next-line max-len
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23BEBEBEFF' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 16px;
    border-radius: 16px;
    min-height: 216px;
    cursor: pointer;

    i {
        font-size: 24px;
    }

    span {
        display: block;
        color: $black64;
        font-weight: 500;
        font-size: .875rem;
        line-height: 1.5;
        margin: 16px 0;

        u {
            color: $accent;
        }

        &:last-child {
            margin: 0;
            font-size: .625rem;
        }
    }

    button {
        background: transparent;
        border: none;
        text-align: center;
        width: 100%;
        height: 100%;
    }

    &:hover {
        background-color: $black4;
    }
}

.dropArea__uploads {
    .dropArea__uploads__file {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: .875rem;
        padding: 2px 0;

        span {
            margin: 0 !important;
            font-size: .875rem !important;
        }
    }
}

.formkit-inner {
    box-shadow: none !important;

    &::before {
        position: absolute;
        left: 24px;
        font-family: 'icomoon' !important;
        speak: never;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        color: $black48;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    input[type=color],  input[type=date],  input[type=datetime-local],  input[type=datetime],  input[type=email],  input[type=month],  input[type=number],  input[type=password],  input[type=search],  input[type=tel],  input[type=text],  input[type=time],  input[type=url],  input[type=week],  select,  textarea {
        padding: 0 24px 0 44px !important;
    }
}

.formkit-outer {
    margin-bottom: 24px;
}

[for=first_name] ~ .formkit-inner, [for=last_name] ~ .formkit-inner {
    &::before {
        content: "\e914";
    }
}

[for=phone] ~ .formkit-inner {
    &::before {
        content: "\e90f";
    }
}

[for=mail] ~ .formkit-inner {
    &::before {
        content: "\e901";
    }
}

[for=available_from] ~ .formkit-inner {
    &::before {
        content: "\e902";
    }
}

[for=available_from] ~ .formkit-inner {
    &::before {
        content: "\e902";
    }
}

[for=salary_expectations] ~ .formkit-inner {
    &::before {
        content: "\e905";
    }
}

.form__dsgvo {
    display: flex;
    align-items: center;
    height: 40px;

    .formkit-messages {
        position: absolute;
    }

    label {
        padding: 0 !important;
        margin: 0 !important;

        p {
            font-size: .875rem !important;
            font-weight: 500 !important;
            line-height: 1.5;
             color: $black64;

            a {
                text-decoration: underline;
            }
        }
    }
}

[data-type="checkbox"] .formkit-input ~ .formkit-decorator, [data-type="radio"] .formkit-input ~ .formkit-decorator {
    background: none;
    display: block;
    width: 16px;
    height: 16px;
    border: 2px solid $accent;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: none !important;
}

[data-type="checkbox"] .formkit-input:checked ~ .formkit-decorator .formkit-icon, [data-type="radio"] .formkit-input:checked ~ .formkit-decorator .formkit-icon {
    svg {
        display: none;
    }

    border: none;
    width: 8px;
    height: 8px;
    border-radius: 2px;
    background-color: $accent;
}

[data-type="button"] .formkit-input, [data-type="submit"] .formkit-input {
    font-weight: 700;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    padding: 0px 32px;
    font-size: 1rem;
    line-height: 64px;
    border: 2px solid $accent;
    background-color: $accent;
    border-radius: 120px;
    color: $white;
    transition: all .25s ease;
    outline: none !important;

    &:hover {
        border: 2px solid $accent32;
        background-color: transparent;
        color: $accent;
    }

    &:active {
        transform: scale(.9, .9);
    }
}
</style>
